<template>
  <b-row>
    <b-col cols="12">
      <b-modal
        :visible="true"
        size="xl"
        :title="editData ? 'Modificar artículo' : 'Añadir artículo libre'"
        :ok-title="editData ? 'Modificar artículo' : 'Añadir artículo libre'"
        :ok-disabled="readOnly"
        :cancel-title="readOnly ? 'Cerrar' : 'Cancelar'"
        id="hover-modal"
        @ok="addProductModalBtn"
        @hidden="modalHidden"
      >
        <b-row>
          <b-col :cols="12">
            <div class="mt-4" v-if="attributes.length > 0">
              <h5>Selectores</h5>

              <b-row> </b-row>
            </div>

            <div class="mt-4">
              <b-row>
                <b-form-group label="Título" class="col-3">
                  <b-form-input
                    type="text"
                    :disabled="readOnly"
                    v-model="productData.reference"
                    @change="changedReference($event)"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Descripción" class="col-5">
                  <b-form-input
                    type="text"
                    :disabled="readOnly"
                    v-model="productData.description"
                    @change="changedDescription($event)"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Precio (IVA)" class="col-2">
                  <b-form-input
                    type="text"
                    :disabled="readOnly"
                    :value="price.replace('.', ',')"
                    @change="changedPrice($event)"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Unidades" class="col-2">
                  <b-form-input
                    type="number"
                    :step="1"
                    :min="1"
                    :disabled="readOnly"
                    v-model.number="quantity"
                    @change="changedQty($event)"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="Comentarios"
                  description="Aparecerán en la orden de taller"
                  class="col-12"
                >
                  <b-form-textarea
                    rows="4"
                    :disabled="readOnly"
                    v-model="comments"
                  ></b-form-textarea>
                </b-form-group>
              </b-row>
            </div>

            <h5 class="mt-4">
              Precio:
              {{ currentPrice.toFixed(2) }}
              €
            </h5>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'FreeTextProductModal',
  props: ['productID', 'editData', 'show', 'readOnly'],

  components: {},
  data() {
    return {
      productData: {
        reference: '',
        type: 'free',
        id: 0,
        description: '',
      },
      attributes: [],
      price: '0.00',
      quantity: 1,
      comments: '',
      currentPrice: 0.0,
    };
  },
  created() {},
  methods: {
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this[name] = val;
    },
    changedQty(qty) {
      this.evaluateUpdatePrice();
    },
    changedPrice(price) {
      this.setDecimal('price', price);

      this.evaluateUpdatePrice();
    },
    updatePrice() {
      actions
        .postProductQuotePrice(this.productData.id, {
          attributes: this.attributes,
          quantity: this.quantity,
          price: this.price,
        })
        .then((x) => {
          this.currentPrice = x.data.price;
        });
    },
    evaluateUpdatePrice() {
      this.updatePrice();
    },
    changedReference(val) {
      this.evaluateUpdatePrice();
    },
    changedDescription(val) {
      this.evaluateUpdatePrice();
    },
    modalHidden() {
      this.$emit('hidden');
    },
    addProductModalBtn(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (this.editData) {
        this.$emit(
          'editProduct',
          this.productData,
          this.attributes,
          this.price,
          this.quantity,
          this.comments,
          null
        );
      } else {
        this.$emit(
          'addProduct',
          this.productData,
          this.attributes,
          this.price,
          this.quantity,
          this.comments,
          null
        );
      }

      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing');
      });
    },
  },
  computed: {},
  mounted() {
    if (this.editData) {
      // editing

      this.price = this.editData.price;
      this.quantity = this.editData.quantity;
      this.comments = this.editData.comments;
      this.productData.reference = this.editData.reference;
      this.productData.description = this.editData.description;

      this.evaluateUpdatePrice();
    }
  },
  updated() {
    //this.renderViews();
  },
};
</script>

<style scoped>
.canvas {
  width: 100%;
  height: 40em;
  /*background: #ebebeb;*/
}
</style>
